export default [{
  name: 'voltz',
  namespaced: true,
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
  },
}]
